<template>
  <el-dialog
    title="保存查询条件"
    :visible.sync="visible"
    width="500px"
  >
    <div>
      <el-form label-width="120px">
        <el-form-item label="查询条件名称">
          <el-input
            placeholder="请输入"
            v-model="filterName"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="saveMyFilter"
          >
            保存
          </el-button>
          <el-button
            @click="closeDialog"
          >
            取消
          </el-button>
        </span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SaveFilterDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      filterName: ''
    }
  },
  methods: {
    saveMyFilter() {
      if (!this.filterName) {
        this.$message({
          type: 'warning',
          message: '请输入筛选条件名称',
        });
        return false;
      }
      let filters = this.params.filtering;
      if (!filters.length) {
        this.$message({
          type: 'warning',
          message: '请添加筛选条件再保存',
        });
        return false;
      }
      this.$emit('save-filter', {
        name: this.filterName,
        filtering: filters
      });
    },
    closeDialog() {
      this.filterName = '';
      this.$emit('update:visible', false);
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        this.filterName = '';
      }
    }
  }
}
</script>